// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E8aPa","right":"styles_right__2CeK_"};